import React, { Fragment } from "react";
import BulkActionApproveButton from "./BulkActionApproveButton";
import BulkActionRejectButton from "./BulkActionRejectButton";
import ApproveAllButton from "./ApproveAllButton";
import BulkActionDeleteButton from "./BulkActionDeleteButton";

const BulkConfirmButton = (props: any) => {
  return (
    <Fragment>
      {props.isPending && (<BulkActionApproveButton {...props} />)}
      {props.isPending && (<BulkActionRejectButton {...props} />)}
      <BulkActionDeleteButton {...props} />
      {props.isPending && (<ApproveAllButton subcontractorId={props.subcontractorId} />)}
    </Fragment>
  );
};

export default BulkConfirmButton;
